import { render } from "./OrdersTable.vue?vue&type=template&id=70cee206&scoped=true"
import script from "./OrdersTable.vue?vue&type=script&lang=js"
export * from "./OrdersTable.vue?vue&type=script&lang=js"

import "./OrdersTable.vue?vue&type=style&index=0&id=70cee206&scoped=true&lang=css"
import "./OrdersTable.vue?vue&type=style&index=1&id=70cee206&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cee206"]])

export default __exports__